// Stop the kcard skeleton shimmer once the product image has painted. Runs
// GLOBALLY (loaded in theme.liquid) so every surface that renders kcards -
// home, collection, related products, search, featured collection - clears
// the shimmer, not only the pages that load collection-filter.js.
(function () {
  var mark = function (img) {
    var media = img.closest && img.closest('.kcard__media');
    if (media) media.classList.add('is-loaded');
  };
  document.addEventListener(
    'load',
    function (event) {
      if (event.target.tagName === 'IMG' && event.target.classList.contains('kcard__img')) {
        mark(event.target);
      }
    },
    true
  );
  // Cached images fire no load event - sweep whatever is already complete.
  var sweep = function () {
    document.querySelectorAll('img.kcard__img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) mark(img);
    });
  };
  if (document.readyState !== 'loading') sweep();
  else document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', sweep);
  // Re-run after cards are injected (lazy-loaded catalog, section re-render).
  window.kodamaSweepCards = sweep;
})();
